function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * ============================================================================
 * IMPORTS
 * ============================================================================
 * @hidden
 */
import * as $array from "./Array";
/**
 * A base class for disposable objects.
 *
 * @ignore Exclude from docs
 */
export var DisposerClass = /*#__PURE__*/function () {
  /**
   * Constructor.
   */
  function DisposerClass() {
    _classCallCheck(this, DisposerClass);
    /**
     * Is object disposed?
     */
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._disposed = false;
  }
  /**
   * Checks if object is disposed.
   *
   * @return Disposed?
   */
  _createClass(DisposerClass, [{
    key: "isDisposed",
    value: function isDisposed() {
      return this._disposed;
    }
    /**
     * Disposes the object.
     */
  }, {
    key: "dispose",
    value: function dispose() {
      if (!this._disposed) {
        this._disposed = true;
        this._dispose();
      }
    }
  }]);
  return DisposerClass;
}();
/**
 * A class for creating an IDisposer.
 *
 * @ignore Exclude from docs
 */
export var Disposer = /*#__PURE__*/function () {
  /**
   * Constructor.
   *
   * @param dispose  Function that disposes object
   */
  function Disposer(dispose) {
    _classCallCheck(this, Disposer);
    /**
     * Is object disposed?
     */
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    /**
     * Method that disposes the object.
     */
    Object.defineProperty(this, "_dispose", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._disposed = false;
    this._dispose = dispose;
  }
  /**
   * Checks if object is disposed.
   *
   * @return Disposed?
   */
  _createClass(Disposer, [{
    key: "isDisposed",
    value: function isDisposed() {
      return this._disposed;
    }
    /**
     * Disposes the object.
     */
  }, {
    key: "dispose",
    value: function dispose() {
      if (!this._disposed) {
        this._disposed = true;
        this._dispose();
      }
    }
  }]);
  return Disposer;
}();
/**
 * This can be extended by other classes to add a `_disposers` property.
 *
 * @ignore Exclude from docs
 */
export var ArrayDisposer = /*#__PURE__*/function (_DisposerClass) {
  _inherits(ArrayDisposer, _DisposerClass);
  var _super = _createSuper(ArrayDisposer);
  function ArrayDisposer() {
    var _this;
    _classCallCheck(this, ArrayDisposer);
    _this = _super.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this), "_disposers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    return _this;
  }
  _createClass(ArrayDisposer, [{
    key: "_dispose",
    value: function _dispose() {
      $array.each(this._disposers, function (x) {
        x.dispose();
      });
    }
  }]);
  return ArrayDisposer;
}(DisposerClass);
/**
 * A collection of related disposers that can be disposed in one go.
 *
 * @ignore Exclude from docs
 */
export var MultiDisposer = /*#__PURE__*/function (_DisposerClass2) {
  _inherits(MultiDisposer, _DisposerClass2);
  var _super2 = _createSuper(MultiDisposer);
  function MultiDisposer(disposers) {
    var _this2;
    _classCallCheck(this, MultiDisposer);
    _this2 = _super2.call(this);
    Object.defineProperty(_assertThisInitialized(_this2), "_disposers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    _this2._disposers = disposers;
    return _this2;
  }
  _createClass(MultiDisposer, [{
    key: "_dispose",
    value: function _dispose() {
      $array.each(this._disposers, function (x) {
        x.dispose();
      });
    }
  }]);
  return MultiDisposer;
}(DisposerClass);
/**
 * A special kind of Disposer that has attached value set.
 *
 * If a new value is set using `set()` method, the old disposer value is
 * disposed.
 *
 * @ignore Exclude from docs
 * @todo Description
 */
export var MutableValueDisposer = /*#__PURE__*/function (_DisposerClass3) {
  _inherits(MutableValueDisposer, _DisposerClass3);
  var _super3 = _createSuper(MutableValueDisposer);
  function MutableValueDisposer() {
    var _this3;
    _classCallCheck(this, MutableValueDisposer);
    _this3 = _super3.apply(this, arguments);
    /**
     * Current disposer.
     */
    Object.defineProperty(_assertThisInitialized(_this3), "_disposer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    /**
     * Current value.
     */
    Object.defineProperty(_assertThisInitialized(_this3), "_value", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    return _this3;
  }
  _createClass(MutableValueDisposer, [{
    key: "_dispose",
    value: function _dispose() {
      if (this._disposer != null) {
        this._disposer.dispose();
        this._disposer = undefined;
      }
    }
    /**
     * Returns current value.
     *
     * @return Value
     */
  }, {
    key: "get",
    value: function get() {
      return this._value;
    }
    /**
     * Sets value and disposes previous disposer if it was set.
     *
     * @param value     New value
     * @param disposer  Disposer
     */
  }, {
    key: "set",
    value: function set(value, disposer) {
      if (this._disposer != null) {
        this._disposer.dispose();
      }
      this._disposer = disposer;
      this._value = value;
    }
    /**
     * Resets the disposer value.
     */
  }, {
    key: "reset",
    value: function reset() {
      this.set(undefined, undefined);
    }
  }]);
  return MutableValueDisposer;
}(DisposerClass);
/**
 * @ignore Exclude from docs
 * @todo Description
 */
export var CounterDisposer = /*#__PURE__*/function (_Disposer) {
  _inherits(CounterDisposer, _Disposer);
  var _super4 = _createSuper(CounterDisposer);
  function CounterDisposer() {
    var _this4;
    _classCallCheck(this, CounterDisposer);
    _this4 = _super4.apply(this, arguments);
    /**
     * [_counter description]
     *
     * @todo Description
     */
    Object.defineProperty(_assertThisInitialized(_this4), "_counter", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    return _this4;
  }
  /**
   * [increment description]
   *
   * @todo Description
   */
  _createClass(CounterDisposer, [{
    key: "increment",
    value: function increment() {
      var _this5 = this;
      // TODO throw an error if it is disposed
      ++this._counter;
      // TODO make this more efficient
      return new Disposer(function () {
        --_this5._counter;
        if (_this5._counter === 0) {
          _this5.dispose();
        }
      });
    }
  }]);
  return CounterDisposer;
}(Disposer);